exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.fix-margin-print[data-v-6b46b0f3]{\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n.fonte[data-v-6b46b0f3]{\n  font-size: 0.875em;\n}\n", "", {"version":3,"sources":["/builds/tjro/stic/dsi/dides-adm/sesiex/chanceler/frontend/olimpia-front/src/components/detalhes/AlertaDivergencia.vue"],"names":[],"mappings":";AACA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB","file":"AlertaDivergencia.vue","sourcesContent":["\n.fix-margin-print[data-v-6b46b0f3]{\n  margin: 0;\n  padding: 0;\n  text-align: center;\n}\n.fonte[data-v-6b46b0f3]{\n  font-size: 0.875em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6b46b0f3","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/detalhes/AlertaDivergencia.vue
// module id = Numd
// module chunks = 1